import { createSelector } from '@reduxjs/toolkit';
import { PassiveParameterTypeEnum } from '../../model/passive/enum/passiveParameterTypeEnum';
import {
  ITemperatureData,
  processTemperatureData,
} from '../../model/passive/temperatureData';
import {
  IActivityTrackerInterval,
  processActivityTrackerData,
} from '../../model/passive/activityTrackerData';
import { SystemState } from '../system/SystemState';

export const dailyParameterDates = (state: SystemState) =>
  state.dailyParameters.dates;

export const selectedDailyParameterData = (state: SystemState) =>
  state.dailyParameters.selectedDailyParameterData;

export const averageWalkingSpeedData = (state: SystemState) =>
  state.dailyParameters.averageWalkingSpeedData;

export const temperatureData = (state: SystemState) =>
  state.dailyParameters.temperatureData || [];

// Returns processed temperature data with calculated statistics
export const processedTemperatureData = createSelector(
  temperatureData,
  (data: ITemperatureData[]) => processTemperatureData(data)
);

export const insoleUsageData = (state: SystemState) =>
  state.dailyParameters.passiveParameterDataMap?.[PassiveParameterTypeEnum.InsoleUsage] || [];

// Returns processed insole usage data with calculated statistics
export const processedInsoleUsageData = createSelector(
  insoleUsageData,
  (data: IActivityTrackerInterval[]) => processActivityTrackerData(data)
);

// Generic selector for any passive parameter type
export const passiveParameterData = (
  state: SystemState,
  parameterType: PassiveParameterTypeEnum
) => {
  if (parameterType === PassiveParameterTypeEnum.Temperature) {
    return state.dailyParameters.temperatureData || [];
  }

  if (parameterType === PassiveParameterTypeEnum.AverageWalkingSpeed) {
    return state.dailyParameters.averageWalkingSpeedData || [];
  }

  // Get from the map for other types
  return state.dailyParameters.passiveParameterDataMap?.[parameterType] || [];
};
